import { render, staticRenderFns } from "./hint.vue?vue&type=template&id=c7fe8c70&scoped=true&"
import script from "./hint.vue?vue&type=script&lang=js&"
export * from "./hint.vue?vue&type=script&lang=js&"
import style0 from "./hint.vue?vue&type=style&index=0&id=c7fe8c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fe8c70",
  null
  
)

export default component.exports